import { isRouteErrorResponse, useRouteError } from 'react-router'
import { useSelector } from 'react-redux'

import { getPlain } from '../store/utils'
import Theme from '../components/Theme'

export default function ErrorBoundary() {
  let viewError = useSelector<State, unknown>((state) => state.getIn(['view', 'error']))
  viewError = getPlain(viewError)
  const error = useRouteError()
  if (isRouteErrorResponse(error)) {
    viewError = { ...error, message: error.data?.message ?? '' }
  }
  return <Theme withLayout error={viewError} currentView="error" />
}
